import { sendGAEvent } from "./ga";

const CATEGORY = "Bulk Upload Interactions";

export const sendPopupOpen = () =>
  sendGAEvent({
    eventCategory: CATEGORY,
    eventAction: "Open popup",
  });
export const addToCart = (amount: number) =>
  sendGAEvent({
    eventCategory: CATEGORY,
    eventAction: "Add to cart",
    eventLabel: `${amount} product(s)`,
  });
export const overrideCart = (amount: number) =>
  sendGAEvent({
    eventCategory: CATEGORY,
    eventAction: "Override Cart",
    eventLabel: `${amount} product(s)`,
  });
